export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14494.244bb2d7.jpg";